import { IDepositResponse, IWithdrawalResponse } from "@finbackoffice/clientbff-client";
import {
    createContext,
    Dispatch,
    FC,
    PropsWithChildren,
    SetStateAction,
    useMemo,
    useState,
} from "react";
import { DepositStepType, WithdrawalStepType } from "../pix-wallet";

interface ITolaWalletDataContext {
    setDepositStep: (step: DepositStepType) => void;
    depositStep: DepositStepType;
    depositData: IDepositResponse | null;
    setDepositData: Dispatch<SetStateAction<IDepositResponse | null>>;
    setWithdrawalStep: (step: WithdrawalStepType) => void;
    withdrawalStep: WithdrawalStepType;
    withdrawalData: IWithdrawalResponse | null;
    setWithdrawalData: Dispatch<SetStateAction<IWithdrawalResponse | null>>;
}

export const TolaWalletDataContext = createContext<ITolaWalletDataContext>(null as any);

export const TolaWalletDataProvider: FC<PropsWithChildren> = ({ children }) => {
    const [depositStep, setDepositStep] = useState<DepositStepType>("first");
    const [depositData, setDepositData] = useState<IDepositResponse | null>(null);
    const [withdrawalStep, setWithdrawalStep] = useState<WithdrawalStepType>("first");
    const [withdrawalData, setWithdrawalData] = useState<IWithdrawalResponse | null>(null);

    const value = useMemo(
        () => ({
            setDepositStep,
            depositStep,
            depositData,
            setDepositData,
            withdrawalStep,
            setWithdrawalStep,
            withdrawalData,
            setWithdrawalData,
        }),
        [
            setDepositStep,
            depositStep,
            depositData,
            setDepositData,
            withdrawalStep,
            setWithdrawalStep,
            withdrawalData,
            setWithdrawalData,
        ],
    );

    return (
        <TolaWalletDataContext.Provider value={value}>{children}</TolaWalletDataContext.Provider>
    );
};
